import { GuideRecruitmentPopup } from './GuideRecruitmentPopup';
import { useGuideRecruitmentCampaign } from '../hooks/useGuideRecruitmentCampaign';

export function GuideRecruitmentCampaignLayer() {
  const { open, content, onPrimaryCta, onDismiss } = useGuideRecruitmentCampaign();

  return (
    <GuideRecruitmentPopup
      open={open}
      content={content}
      onPrimaryCta={onPrimaryCta}
      onDismiss={onDismiss}
    />
  );
}
